export var AddressRequirement;
(function (AddressRequirement) {
    AddressRequirement[AddressRequirement["NONE"] = 0] = "NONE";
    AddressRequirement[AddressRequirement["ANY"] = 1] = "ANY";
    AddressRequirement[AddressRequirement["LOCAL"] = 2] = "LOCAL";
    AddressRequirement[AddressRequirement["FOREIGN"] = 3] = "FOREIGN";
})(AddressRequirement || (AddressRequirement = {}));
export var LinePurchaseError;
(function (LinePurchaseError) {
    LinePurchaseError[LinePurchaseError["PHONE_NUMBER_REQUIRES_ADDRESS"] = -120000] = "PHONE_NUMBER_REQUIRES_ADDRESS";
    LinePurchaseError[LinePurchaseError["PHONE_NUMBER_REQUIRES_LOCAL_ADDRESS"] = -120001] = "PHONE_NUMBER_REQUIRES_LOCAL_ADDRESS";
    LinePurchaseError[LinePurchaseError["PHONE_NUMBER_REQUIRES_FOREIGN_ADDRESS"] = -120002] = "PHONE_NUMBER_REQUIRES_FOREIGN_ADDRESS";
    LinePurchaseError[LinePurchaseError["ADDRESS_CANNOT_BE_VALIDATED"] = -120003] = "ADDRESS_CANNOT_BE_VALIDATED";
    LinePurchaseError[LinePurchaseError["IDENTITY_DOCUMENT_REQUIRED"] = -120004] = "IDENTITY_DOCUMENT_REQUIRED";
})(LinePurchaseError || (LinePurchaseError = {}));
//# sourceMappingURL=available-phone-number.i.js.map